<section class="unit-events-page">


  <div class="feature-page__content">

    <!-- Loading -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <!-- Error -->
    <div *ngIf="errorMessage && !isLoading" class="error-container">
      <mat-icon color="warn">error</mat-icon>
      <p>{{ errorMessage }}</p>
    </div>

    <div *ngIf="!isLoading && !errorMessage" class="unit-content">

      <div class="events-content">

        <app-table-surface
          tableId="unit-events"
          title="Historial de eventos"
          titleIcon="event_note"
          [columns]="columns"
          [data]="visibleEvents"
          [enableRowHover]="false"
          tableHeight="auto"
          [cellTemplate]="eventCell"
          [enableSearch]="true"
          searchPlaceholder="Buscar eventos..."
          [enableSort]="true"
          [initialSort]="sortState"
          [sortState]="sortState"
          [enableColumnVisibility]="true"
          [enableDensity]="true"
          [readonly]="!(canManageMemberData$ | async)"
          primaryActionLabel="Nuevo"
          [noDataMessage]="searchTerm ? 'No se encontraron eventos.' : 'Esta unidad todavía no tiene eventos registrados.'"
          (searchChange)="searchTerm = $event"
          (sortChange)="sortState = $event"
          (toolbarSortChange)="sortState = $event"
          (primaryActionClick)="onShowAddForm()">
        </app-table-surface>

        <ng-template #eventCell let-column="column" let-event="row">
          <span *ngIf="column === 'eventType'" class="event-type-cell">
            <mat-icon>{{ getEventTypeIcon(event) }}</mat-icon>
            {{ getEventTypeLabel(event) }}
          </span>
          <span *ngIf="column === 'eventDate'" class="date-cell">{{ event.eventDate | date: 'dd/MM/yyyy' }}</span>
          <span *ngIf="column === 'notes'" class="notes-cell">{{ event.notes || '—' }}</span>
          <span *ngIf="column === 'actions' && (canManageMemberData$ | async)" class="actions-cell">
            <button mat-icon-button (click)="onEditEvent(event)" matTooltip="Editar" aria-label="Editar evento" [disabled]="editingEventId !== null">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="onDelete(event)" matTooltip="Eliminar" aria-label="Eliminar evento" [disabled]="editingEventId !== null">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </span>
        </ng-template>
      </div>
    </div>
  </div>
</section>

<ng-template #eventDialog>
  <app-modal-shell [config]="{ title: editingEventId !== null ? 'Editar evento' : 'Nuevo evento', size: 'md', layout: 'form' }">
    <form modal-content id="unit-event-form" [formGroup]="eventForm" (ngSubmit)="onSubmit()" class="event-dialog-fields">
      <mat-form-field appearance="fill" subscriptSizing="dynamic">
        <mat-label>Tipo de evento</mat-label>
        <mat-select formControlName="eventTypeId" required>
          <mat-option *ngFor="let type of eventTypeOptions" [value]="type.value">{{ type.name }}</mat-option>
        </mat-select>
        <mat-error *ngIf="eventForm.get('eventTypeId')?.hasError('required')">Seleccioná un tipo de evento.</mat-error>
      </mat-form-field>
      <app-date-picker label="Fecha" formControlName="eventDate" [errorMessages]="{ required: 'Ingresá la fecha del evento.' }"></app-date-picker>
      <mat-form-field appearance="fill" subscriptSizing="dynamic">
        <mat-label>Notas (opcional)</mat-label>
        <textarea matInput formControlName="notes" rows="3"></textarea>
      </mat-form-field>
    </form>
    <ng-container modal-actions>
      <button mat-button type="button" (click)="onCancelEdit()" [disabled]="isSaving">Cancelar</button>
      <button mat-flat-button color="primary" type="submit" form="unit-event-form" [disabled]="isSaving">
        {{ isSaving ? 'Guardando…' : (editingEventId !== null ? 'Guardar cambios' : 'Agregar evento') }}
      </button>
    </ng-container>
  </app-modal-shell>
</ng-template>
